import React from 'react';
import { withTranslate } from 'react-redux-multilingual';
import { useNavigate, Link } from 'react-router-dom';
import Zoom from 'react-medium-image-zoom';
import Box from '@mui/material/Box';
import Typography from '@mui/material/Typography';

import ParametersTableHeader from '../../Blocks/ParametersTableHeader';
import ParametersTypeValue from '../../Blocks/ParametersTypeValue';
import ReturnTypeValue from '../../Blocks/ReturnTypeValue';

import BasicAuth from '../../../../../libraries/Images/basicAuth.png';

function En(props) {
    const { translate } = props;
    return (
        <Box>
            <Typography variant="h5" gutterBottom id="openbrowser">
                1.&nbsp;<span className="material-symbols-outlined">web_asset</span>&nbsp;{translate('openbrowser')}
            </Typography>
            <p><strong>{translate('openbrowser')}</strong> ブラウザのアクションのリストです。ブラウザのアクションは、ブラウザの起動やブラウザ内でのクリックなどの多様なアクションに対応できます。ブラウザで自動操作するため、CSSセレクターを設定する必要です。CSS セレクタの取得方法はこちらです。</p>
            <ul style={{ listStyle: "none" }}>
                <p>
                    <strong>a.&nbsp;{translate('parameters__title')}</strong>
                </p>
                <li>
                    <table className='parameters'>
                        <ParametersTableHeader />
                        <tbody>
                            <tr>
                                <td>{translate('outputkey')}<span>*</span></td>
                                <td>
                                    <ParametersTypeValue type="text" />
                                </td>
                                <td>開いたブラウザのWebページのアドレスの保存先です。</td>
                                <td>$browser_1</td>
                            </tr>
                            <tr>
                                <td>{translate('url')}<span>*</span></td>
                                <td>
                                    <ParametersTypeValue type="text" />
                                </td>
                                <td>開きたいWebページのアドレス</td>
                                <td></td>
                            </tr>
                            <tr>
                                <td>{translate('windowsize')}</td>
                                <td>
                                    <ParametersTypeValue type="text" />
                                </td>
                                <td>ブラウザ起動時の画面サイズ</td>
                                <td>1280 x 1024</td>
                            </tr>
                            <tr>
                                <td>{translate('language')}</td>
                                <td>
                                    <ParametersTypeValue type="text" />
                                </td>
                                <td>ブラウザ言語</td>
                                <td>English</td>
                            </tr>
                            <tr>
                                <td>{translate('basicauthusername')}</td>
                                <td>
                                    <ParametersTypeValue type="text" />
                                </td>
                                <td>ダイアログボックス内のユーザー名 (補足の❶を参照)二段階認証対応のため</td>
                                <td></td>
                            </tr>
                            <tr>
                                <td>{translate('basicauthpassword')}</td>
                                <td>
                                    <ParametersTypeValue type="text" />
                                </td>
                                <td>ダイアログ内のパスワード（補足の❷を参照）二段階認証対応のため</td>
                                <td></td>
                            </tr>
                            <tr>
                                <td>{translate('acceptdialog')}</td>
                                <td>
                                    <ParametersTypeValue type="boolean" />
                                </td>
                                <td> ダイアログ内のボタンをクリックするアクション。ダイアログ受け入れスイッチがオン (true)<strong>{translate('acceptdialog')}</strong> の場合は、<strong>{translate('signin')}</strong> ボタンをクリックします (サイドバー番号 ❸ を参照)。 </td>
                                <td>true</td>
                            </tr>
                            <tr>
                                <td>{translate('screenshot')}</td>
                                <td>
                                    <ParametersTypeValue type="boolean" />
                                </td>
                                <td>ブラウザがアクションを完了した後に撮影された画像。スクリーンショット <strong>{translate('screenshot')}</strong> スイッチがオン (true) の場合、画像はキャプチャされてストレージに保存されます。 </td>
                                <td>true</td>
                            </tr>
                        </tbody>
                    </table>
                </li>
                <p><strong>{translate('supplement__title')}</strong></p>
                <li>
                    <div className='supplement'>
                        <p>ブラウザにダイアログ ボックスが表示される場合</p>
                        <Zoom>
                            <img src={BasicAuth} width="75%" />
                        </Zoom>
                    </div>
                </li>
                <p>
                    <strong>b.&nbsp;{translate('returndatatype__title')}</strong>
                </p>
                <li>
                    <ReturnTypeValue type="text" />
                </li>
                <p>
                    <strong>c.&nbsp;{translate('example__title')}</strong>
                </p>
                <li>
                    <div className='results'>
                        <div className='parameter'>
                            <span className='parameter-name'>{translate('outputkey')}</span>
                            <div>$browser_1</div>
                        </div>
                        <div className='parameter'>
                            <span className='parameter-name'>{translate('url')}</span>
                            <div>https://rpa-cloud.io/</div>
                        </div>
                        <div className='output'>
                            <span className='output-symbol'>&#61;&gt;&nbsp;</span>
                            <div>ws://127.0.0.1:58580/devtools/browser/e490bb1b-e478-48c2-a8e1-7f5e2da46e0</div>
                        </div>
                    </div>
                </li>
            </ul>
            <Typography variant="h5" gutterBottom id="typetext">
                2.&nbsp;<span className="material-symbols-outlined">text_fields</span>&nbsp;{translate('typetext')}
            </Typography>
            <p><strong>{translate('typetext')}</strong> Web サイト上入力したい位置にテキストを入力するアクションです。</p>
            <ul style={{ listStyle: "none" }}>
                <p>
                    <strong>a.&nbsp;{translate('parameters__title')}</strong>
                </p>
                <li>
                    <table className='parameters'>
                        <ParametersTableHeader />
                        <tbody>
                            <tr>
                                <td>{translate('browser')}<span>*</span></td>
                                <td>
                                    <ParametersTypeValue type="text" />
                                </td>
                                <td>テキストを入力する対象の Web サイトの出力きー</td>
                                <td></td>
                            </tr>
                            <tr>
                                <td>{translate('selector')}<span>*</span></td>
                                <td>
                                    <ParametersTypeValue type="text" />
                                </td>
                                <td>Web サイト上のテキスト入力フィールドの CSS セレクタです。 CSS セレクタの取得方法は <a href="/control-center/documentation/gettingstarted/usage/#getcssselector" target="_blank">こちら</a>です。</td>
                                <td></td>
                            </tr>
                            <tr>
                                <td>{translate('text')}<span>*</span></td>
                                <td>
                                    <ParametersTypeValue type="text" />
                                </td>
                                <td>入力したい文字</td>
                                <td></td>
                            </tr>
                            <tr>
                                <td>{translate('clearvalue')}</td>
                                <td>
                                    <ParametersTypeValue type="boolean" />
                                </td>
                                <td>すべてのテキストを削除するアクションです。値を削除スイッチがオン (true) の場合、前のテキストは削除され、新しいテキストに置き換えられます。 <strong>{translate('clearvalue')}</strong> .</td>
                                <td>true</td>
                            </tr>
                            <tr>
                                <td>{translate('screenshot')}</td>
                                <td>
                                    <ParametersTypeValue type="boolean" />
                                </td>
                                <td>アクションが完了した後に撮影された画像。スクリーンショット <strong>{translate('screenshot')}</strong> スイッチがオン (true) の場合、画像はキャプチャされてストレージに保存されます。 </td>
                                <td>true</td>
                            </tr>
                            <tr>
                                <td>{translate('ignoreerror')}</td>
                                <td>
                                    <ParametersTypeValue type="boolean" />
                                </td>
                                <td>エラーを無視するアクションとして、エラー無視スイッチがオン (true) の場合、CSS セレクターが見つからないなどのエラーが発生した場合でも、ブラウザーはさらなるアクションを続行します。 <strong>{translate('ignoreerror')}</strong> </td>
                                <td>true</td>
                            </tr>
                        </tbody>
                    </table>
                </li>
                <p>
                    <strong>b.&nbsp;{translate('returndatatype__title')}</strong>
                </p>
                <li>
                    <ReturnTypeValue />
                </li>
                <p>
                    <strong>c.&nbsp;{translate('example__title')}</strong>
                </p>
                <li>

                    <div className='results'>
                        <div className='parameter'>
                            <span className='parameter-name'>{translate('browser')}</span>
                            <div>$browser_1</div>
                        </div>
                        <div className='parameter'>
                            <span className='parameter-name'>{translate('selector')}</span>
                            <div>input.username</div>
                        </div>
                        <div className='parameter'>
                            <span className='parameter-name'>{translate('text')}</span>
                            <div>support@rpa-cloud.io</div>
                        </div>
                    </div>
                </li>
            </ul>
            <Typography variant="h5" gutterBottom id="typepassword">
                3.&nbsp;<span className="material-symbols-outlined">password</span>&nbsp;{translate('typepassword')}
            </Typography>
            <p><strong>{translate('typepassword')}</strong> はテキスト入力と同じように機能しますが、パスワードは非表示になります。 {translate('typetext')}</p>
            <ul style={{ listStyle: "none" }}>
                <p>
                    <strong>a.&nbsp;{translate('parameters__title')}</strong>
                </p>
                <li>
                    <table className='parameters'>
                        <ParametersTableHeader />
                        <tbody>
                            <tr>
                                <td>{translate('browser')}<span>*</span></td>
                                <td>
                                    <ParametersTypeValue type="text" />
                                </td>
                                <td>パスワードを入力する対象の Web サイトの出力きー</td>
                                <td></td>
                            </tr>
                            <tr>
                                <td>{translate('selector')}<span>*</span></td>
                                <td>
                                    <ParametersTypeValue type="text" />
                                </td>
                                <td> Web サイト上のパスワード入力フィールドの CSS セレクタです。CSS セレクタの取得方法は<a href="/control-center/documentation/gettingstarted/usage/#getcssselector" target="_blank">こちら</a> です。 </td>
                                <td></td>
                            </tr>
                            <tr>
                                <td>Password<span>*</span></td>
                                <td>
                                    <ParametersTypeValue type="text" />
                                </td>
                                <td>入力したいパスワード</td>
                                <td></td>
                            </tr>
                            <tr>
                                <td>{translate('clearvalue')}</td>
                                <td>
                                    <ParametersTypeValue type="boolean" />
                                </td>
                                <td>すべてのテキストを削除するアクションです。値を削除スイッチがオン (true) の場合、前のテキストは削除され、新しいテキストに置き換えられます。 <strong>{translate('clearvalue')}</strong> </td>
                                <td>true</td>
                            </tr>
                            <tr>
                                <td>{translate('screenshot')}</td>
                                <td>
                                    <ParametersTypeValue type="boolean" />
                                </td>
                                <td>アクションが完了した後に撮影された画像。スクリーンショット <strong>{translate('screenshot')}</strong> スイッチがオン (true) の場合、画像はキャプチャされてストレージに保存されます。 </td>
                                <td>true</td>
                            </tr>
                            <tr>
                                <td>{translate('ignoreerror')}</td>
                                <td>
                                    <ParametersTypeValue type="boolean" />
                                </td>
                                <td>エラーを無視するアクションとして、エラー無視スイッチがオン (true) の場合、CSS セレクターが見つからないなどのエラーが発生した場合でも、ブラウザーはさらなるアクションを続行します。 <strong>{translate('ignoreerror')}</strong> </td>
                                <td>true</td>
                            </tr>
                        </tbody>
                    </table>
                </li>
                <p>
                    <strong>b.&nbsp;{translate('returndatatype__title')}</strong>
                </p>
                <li>
                    <ReturnTypeValue />
                </li>
                <p>
                    <strong>c.&nbsp;{translate('example__title')}</strong>
                </p>
                <li>

                    <div className='results'>
                        <div className='parameter'>
                            <span className='parameter-name'>{translate('browser')}</span>
                            <div>$browser_1</div>
                        </div>
                        <div className='parameter'>
                            <span className='parameter-name'>{translate('selector')}</span>
                            <div>input.password</div>
                        </div>
                        <div className='parameter'>
                            <span className='parameter-name'>Password</span>
                            <div>Abc123#</div>
                        </div>
                    </div>
                </li>
            </ul>
            <Typography variant="h5" gutterBottom id="click">
                4.&nbsp;<span className="material-symbols-outlined">ads_click</span>&nbsp;{translate('click')}
            </Typography>
            <p><strong>{translate('click')}</strong> Web サイト上クリックしたい位置にクリックするアクションです。</p>
            <ul style={{ listStyle: "none" }}>
                <p>
                    <strong>a.&nbsp;{translate('parameters__title')}</strong>
                </p>
                <li>
                    <table className='parameters'>
                        <ParametersTableHeader />
                        <tbody>
                            <tr>
                                <td>{translate('browser')}<span>*</span></td>
                                <td>
                                    <ParametersTypeValue type="text" />
                                </td>
                                <td>クリックする対象の Web サイトの出力きー</td>
                                <td></td>
                            </tr>
                            <tr>
                                <td>{translate('selector')}<span>*</span></td>
                                <td>
                                    <ParametersTypeValue type="text" />
                                </td>
                                <td> Web サイト上のクリックしたい位置の CSS セレクタです。 CSS セレクタの取得方法は<a href="/control-center/documentation/gettingstarted/usage/#getcssselector" target="_blank">こちら</a> です。</td>
                                <td></td>
                            </tr>
                            <tr>
                                <td>{translate('waitfornavigation')}</td>
                                <td>
                                    <ParametersTypeValue type="boolean" />
                                </td>
                                <td>クリックしたい位置のCSS セレクタが表示されるまでのアクションとして、もしセレクターを待つスイッチがオン (true) の場合は、クリックしたい位置のCSS セレクタが表示されてから、クリックアクションに進みます。 <strong>{translate('waitfornavigation')}</strong></td>
                                <td>true</td>
                            </tr>
                            <tr>
                                <td>{translate('acceptdialog')}</td>
                                <td>
                                    <ParametersTypeValue type="boolean" />
                                </td>
                                <td>ダイアログのボタンをクリックするアクション。ダイアログ受入スイッチがオン (true) の場合は、サインイン ボタンをクリックします (補足の番号 ❸ を参照)。 <strong>{translate('acceptdialog')}</strong> <strong>{translate('signin')}</strong> </td>
                                <td>true</td>
                            </tr>
                            <tr>
                                <td>{translate('screenshot')}</td>
                                <td>
                                    <ParametersTypeValue type="boolean" />
                                </td>
                                <td>アクションが完了した後に撮影された画像。スクリーンショット <strong>{translate('screenshot')}</strong> スイッチがオン (true) の場合、画像はキャプチャされてストレージに保存されます。  <strong>{translate('screenshot')}</strong> </td>
                                <td>true</td>
                            </tr>
                            <tr>
                                <td>{translate('ignoreerror')}</td>
                                <td>
                                    <ParametersTypeValue type="boolean" />
                                </td>
                                <td>エラーを無視するアクションとして、エラー無視スイッチがオン (true) の場合、CSS セレクターが見つからないなどのエラーが発生した場合でも、ブラウザーはさらなるアクションを続行します。 <strong>{translate('ignoreerror')}</strong> </td>
                                <td>true</td>
                            </tr>
                        </tbody>
                    </table>
                </li>
                <p><strong>{translate('supplement__title')}</strong></p>
                <li>
                    <div className='supplement'>
                        <p>ブラウザにダイアログ ボックスが表示される場合</p>
                        <Zoom>
                            <img src={BasicAuth} width="75%" />
                        </Zoom>
                    </div>
                </li>
                <p>
                    <strong>b.&nbsp;{translate('returndatatype__title')}</strong>
                </p>
                <li>
                    <ReturnTypeValue />
                </li>
                <p>
                    <strong>c.&nbsp;{translate('example__title')}</strong>
                </p>
                <li>

                    <div className='results'>
                        <div className='parameter'>
                            <span className='parameter-name'>{translate('browser')}</span>
                            <div>$browser_1</div>
                        </div>
                        <div className='parameter'>
                            <span className='parameter-name'>{translate('selector')}</span>
                            <div>button.signin</div>
                        </div>
                    </div>
                </li>
            </ul>
            <Typography variant="h5" gutterBottom id="selectoption">
                5.&nbsp;<span className="material-symbols-outlined">checklist</span>&nbsp;{translate('selectoption')}
            </Typography>
            <p><strong>{translate('selectoption')}</strong> ドロップダウン リストから値を選択するアクションです。</p>
            <ul style={{ listStyle: "none" }}>
                <p>
                    <strong>a.&nbsp;{translate('parameters__title')}</strong>
                </p>
                <li>
                    <table className='parameters'>
                        <ParametersTableHeader />
                        <tbody>
                            <tr>
                                <td>{translate('browser')}<span>*</span></td>
                                <td>
                                    <ParametersTypeValue type="text" />
                                </td>
                                <td>ドロップダウン リストを選択する対象の Web サイトの出力きー</td>
                                <td></td>
                            </tr>
                            <tr>
                                <td>{translate('selector')}<span>*</span></td>
                                <td>
                                    <ParametersTypeValue type="text" />
                                </td>
                                <td>Web サイト上のドロップダウン リストの CSS セレクタです。 CSS セレクタの取得方法は<a href="/control-center/documentation/gettingstarted/usage/#getcssselector" target="_blank">こちら</a> です。</td>
                                <td></td>
                            </tr>
                            <tr>
                                <td>{translate('text')}<span>*</span></td>
                                <td>
                                    <ParametersTypeValue type="boolean" />
                                </td>
                                <td>リストに選択したいテキスト </td>
                                <td></td>
                            </tr>
                            <tr>
                                <td>{translate('screenshot')}</td>
                                <td>
                                    <ParametersTypeValue type="boolean" />
                                </td>
                                <td>アクションが完了した後に撮影された画像。スクリーンショット <strong>{translate('screenshot')}</strong> スイッチがオン (true) の場合、画像はキャプチャされてストレージに保存されます。 </td>
                                <td>true</td>
                            </tr>
                            <tr>
                                <td>{translate('ignoreerror')}</td>
                                <td>
                                    <ParametersTypeValue type="boolean" />
                                </td>
                                <td>エラーを無視するアクションとして、エラー無視スイッチがオン (true) の場合、CSS セレクターが見つからないなどのエラーが発生した場合でも、ブラウザーはさらなるアクションを続行します。 <strong>{translate('ignoreerror')}</strong> </td>
                                <td>true</td>
                            </tr>
                        </tbody>
                    </table>
                </li>
                <p>
                    <strong>b.&nbsp;{translate('returndatatype__title')}</strong>
                </p>
                <li>
                    <ReturnTypeValue />
                </li>
                <p>
                    <strong>c.&nbsp;{translate('example__title')}</strong>
                </p>
                <li>

                    <div className='results'>
                        <div className='parameter'>
                            <span className='parameter-name'>{translate('browser')}</span>
                            <div>$browser_1</div>
                        </div>
                        <div className='parameter'>
                            <span className='parameter-name'>{translate('selector')}</span>
                            <div>select.gender</div>
                        </div>
                        <div className='parameter'>
                            <span className='parameter-name'>{translate('text')}</span>
                            <div>male</div>
                        </div>
                    </div>
                </li>
            </ul>
            <Typography variant="h5" gutterBottom id="keyboardpress">
                6.&nbsp;<span className="material-symbols-outlined">keyboard_command_key</span>&nbsp;{translate('keyboardpress')}
            </Typography>
            <p><strong>{translate('keyboardpress')}</strong>キーボードのキーを押すアクションです。</p>
            <ul style={{ listStyle: "none" }}>
                <p>
                    <strong>a.&nbsp;{translate('parameters__title')}</strong>
                </p>
                <li>
                    <table className='parameters'>
                        <ParametersTableHeader />
                        <tbody>
                            <tr>
                                <td>{translate('browser')}<span>*</span></td>
                                <td>
                                    <ParametersTypeValue type="text" />
                                </td>
                                <td>キーボードのキーを押す対象の Web サイトの出力きー</td>
                                <td></td>
                            </tr>
                            <tr>
                                <td>{translate('keyboards')}<span>*</span></td>
                                <td>
                                    <ParametersTypeValue type="text" />
                                </td>
                                <td>キーボード上のキーの名前です。使用可能なキー名のリストについては、<a href="https://github.com/puppeteer/puppeteer/blob/1ecb6e3f19c970257626d58ea2fa5323195fc1f2/src/common/USKeyboardLayout.ts" target="_blank">こちら</a> を参照してください。</td>
                                <td></td>
                            </tr>
                            <tr>
                                <td>{translate('screenshot')}</td>
                                <td>
                                    <ParametersTypeValue type="boolean" />
                                </td>
                                <td>アクションが完了した後に撮影された画像。スクリーンショット <strong>{translate('screenshot')}</strong> スイッチがオン (true) の場合、画像はキャプチャされてストレージに保存されます。 </td>
                                <td>true</td>
                            </tr>
                        </tbody>
                    </table>
                </li>
                <p>
                    <strong>b.&nbsp;{translate('returndatatype__title')}</strong>
                </p>
                <li>
                    <ReturnTypeValue />
                </li>
                <p>
                    <strong>c.&nbsp;{translate('example__title')}</strong>
                </p>
                <li>

                    <div className='results'>
                        <div className='parameter'>
                            <span className='parameter-name'>{translate('browser')}</span>
                            <div>$browser_1</div>
                        </div>
                        <div className='parameter'>
                            <span className='parameter-name'>{translate('keyboards')}</span>
                            <div>ArrowLeft,Enter</div>
                        </div>
                    </div>
                </li>
            </ul>
            <Typography variant="h5" gutterBottom id="downloadfile">
                7.&nbsp;<span className="material-symbols-outlined">file_download</span>&nbsp;{translate('downloadfile')}
            </Typography>
            <p><strong>{translate('downloadfile')}</strong> ファイルをダウンロードするアクションです。ファイルはストレージに保存されます。</p>
            <ul style={{ listStyle: "none" }}>
                <p>
                    <strong>a.&nbsp;{translate('parameters__title')}</strong>
                </p>
                <li>
                    <table className='parameters'>
                        <ParametersTableHeader />
                        <tbody>
                            <tr>
                                <td>{translate('outputkey')}<span>*</span></td>
                                <td>
                                    <ParametersTypeValue type="text" />
                                </td>
                                <td>ダウンロードしたファイルの保存先</td>
                                <td>$file_1</td>
                            </tr>
                            <tr>
                                <td>{translate('browser')}<span>*</span></td>
                                <td>
                                    <ParametersTypeValue type="text" />
                                </td>
                                <td>ファイルダウンロードする対象の Web サイトの出力きー</td>
                                <td></td>
                            </tr>
                            <tr>
                                <td>{translate('actionsfordownload')}<span>*</span></td>
                                <td>
                                    <ParametersTypeValue type="text" />
                                </td>
                                <td>ファイルのダウンロードをトリガーするアクション。アクションがドロップダウンリストからの選択の場合、テキスト値を入力する必要があります <strong>{translate('selectoption')}</strong>,  <strong>{translate('text')}</strong> </td>
                                <td>{translate('click')}</td>
                            </tr>
                            <tr>
                                <td>{translate('selector')}<span>*</span></td>
                                <td>
                                    <ParametersTypeValue type="text" />
                                </td>
                                <td> Web サイト上のファイルのダウンロードをトリガーするの CSS セレクタです。CSS セレクタの取得方法は<a href="/control-center/documentation/gettingstarted/usage/#getcssselector" target="_blank">こちら</a> です。</td>
                                <td></td>
                            </tr>
                            <tr>
                                <td>{translate('text')}<span>*</span></td>
                                <td>
                                    <ParametersTypeValue type="text" />
                                </td>
                                <td>ドロップダウンリストに選択したいテキスト</td>
                                <td></td>
                            </tr>
                            <tr>
                                <td>{translate('screenshot')}</td>
                                <td>
                                    <ParametersTypeValue type="boolean" />
                                </td>
                                <td>アクションが完了した後に撮影された画像。スクリーンショット <strong>{translate('screenshot')}</strong> スイッチがオン (true) の場合、画像はキャプチャされてストレージに保存されます。 </td>
                                <td>true</td>
                            </tr>
                            <tr>
                                <td>{translate('ignoreerror')}</td>
                                <td>
                                    <ParametersTypeValue type="boolean" />
                                </td>
                                <td>エラーを無視するアクションとして、エラー無視スイッチがオン (true) の場合、CSS セレクターが見つからないなどのエラーが発生した場合でも、ブラウザーはさらなるアクションを続行します。 <strong>{translate('ignoreerror')}</strong> </td>
                                <td>true</td>
                            </tr>
                        </tbody>
                    </table>
                </li>
                <p>
                    <strong>b.&nbsp;{translate('returndatatype__title')}</strong>
                </p>
                <li>
                    <ReturnTypeValue type="text" />
                </li>
                <p>
                    <strong>c.&nbsp;{translate('example__title')}</strong>
                </p>
                <li>
                    <div className='results'>
                        <div className='parameter'>
                            <span className='parameter-name'>{translate('outputkey')}</span>
                            <div>$file_1</div>
                        </div>
                        <div className='parameter'>
                            <span className='parameter-name'>{translate('browser')}</span>
                            <div>$browser_1</div>
                        </div>
                        <div className='parameter'>
                            <span className='parameter-name'>{translate('actionsfordownload')}</span>
                            <div>Click</div>
                        </div>
                        <div className='parameter'>
                            <span className='parameter-name'>{translate('selector')}</span>
                            <div>button.download</div>
                        </div>
                        <div className='output'>
                            <span className='output-symbol'>&#61;&gt;&nbsp;</span>
                            <div>/tmp/downloads/bot-sktwi9ovlb7lrmpt/his-20221208-0531394260/data.xlsx</div>
                        </div>
                    </div>
                </li>
            </ul>
            <Typography variant="h5" gutterBottom id="uploadfile">
                8.&nbsp;<span className="material-symbols-outlined">file_upload</span>&nbsp;{translate('uploadfile')}
            </Typography>
            <p><strong>{translate('uploadfile')}</strong> ストレージに保存されたファイルをアップロードアクションです。</p>
            <ul style={{ listStyle: "none" }}>
                <p>
                    <strong>a.&nbsp;{translate('parameters__title')}</strong>
                </p>
                <li>
                    <table className='parameters'>
                        <ParametersTableHeader />
                        <tbody>
                            <tr>
                                <td>{translate('browser')}<span>*</span></td>
                                <td>
                                    <ParametersTypeValue type="text" />
                                </td>
                                <td>ファイルアップロードする対象の Web サイトの出力きー</td>
                                <td></td>
                            </tr>
                            <tr>
                                <td>{translate('selector')}<span>*</span></td>
                                <td>
                                    <ParametersTypeValue type="text" />
                                </td>
                                <td>Web サイト上のファイルのアップロードするの CSS セレクタです。CSS セレクタの取得方法は<a href="/control-center/documentation/gettingstarted/usage/#getcssselector" target="_blank">こちら</a> です。</td>
                                <td></td>
                            </tr>
                            <tr>
                                <td>{translate('filepath')}<span>*</span></td>
                                <td>
                                    <ParametersTypeValue type="text" />
                                </td>
                                <td>アップロードするファイルのストレージ アドレスです。</td>
                                <td></td>
                            </tr>
                        </tbody>
                    </table>
                </li>
                <p>
                    <strong>b.&nbsp;{translate('returndatatype__title')}</strong>
                </p>
                <li>
                    <ReturnTypeValue />
                </li>
                <p>
                    <strong>c.&nbsp;{translate('example__title')}</strong>
                </p>
                <li>

                    <div className='results'>
                        <div className='parameter'>
                            <span className='parameter-name'>{translate('browser')}</span>
                            <div>$browser_1</div>
                        </div>
                        <div className='parameter'>
                            <span className='parameter-name'>{translate('selector')}</span>
                            <div>input.upload</div>
                        </div>
                        <div className='parameter'>
                            <span className='parameter-name'>{translate('filepath')}</span>
                            <div>/tmp/downloads/bot-sktwi9ovlb7lrmpt/his-20221208-0531394260/data.xlsx</div>
                        </div>
                    </div>
                </li>
            </ul>
            <Typography variant="h5" gutterBottom id="gettext">
                9.&nbsp;<span className="material-symbols-outlined">text_increase</span>&nbsp;{translate('gettext')}
            </Typography>
            <p><strong>{translate('gettext')}</strong> ブラウザ内の指定された要素内のすべてのテキストを取得するアクションです。</p>
            <ul style={{ listStyle: "none" }}>
                <p>
                    <strong>a.&nbsp;{translate('parameters__title')}</strong>
                </p>
                <li>
                    <table className='parameters'>
                        <ParametersTableHeader />
                        <tbody>
                            <tr>
                                <td>{translate('outputkey')}<span>*</span></td>
                                <td>
                                    <ParametersTypeValue type="text" />
                                </td>
                                <td>取得したテキストの保存先です。</td>
                                <td>$text_1</td>
                            </tr>
                            <tr>
                                <td>{translate('browser')}<span>*</span></td>
                                <td>
                                    <ParametersTypeValue type="text" />
                                </td>
                                <td>テキスト取得する対象の Web サイトの出力きー</td>
                                <td></td>
                            </tr>
                            <tr>
                                <td>{translate('selector')}<span>*</span></td>
                                <td>
                                    <ParametersTypeValue type="text" />
                                </td>
                                <td>Web サイト上のテキスト位置の CSS セレクタです。  CSS セレクタの取得方法は<a href="/control-center/documentation/gettingstarted/usage/#getcssselector" target="_blank">こちら</a> です。</td>
                                <td></td>
                            </tr>
                            <tr>
                                <td>{translate('screenshot')}</td>
                                <td>
                                    <ParametersTypeValue type="boolean" />
                                </td>
                                <td>アクションが完了した後に撮影された画像。スクリーンショット <strong>{translate('screenshot')}</strong> スイッチがオン (true) の場合、画像はキャプチャされてストレージに保存されます。 </td>
                                <td>true</td>
                            </tr>
                            <tr>
                                <td>{translate('ignoreerror')}</td>
                                <td>
                                    <ParametersTypeValue type="boolean" />
                                </td>
                                <td>エラーを無視するアクションとして、エラー無視スイッチがオン (true) の場合、CSS セレクターが見つからないなどのエラーが発生した場合でも、ブラウザーはさらなるアクションを続行します。 <strong>{translate('ignoreerror')}</strong> </td>
                                <td>true</td>
                            </tr>
                        </tbody>
                    </table>
                </li>
                <p>
                    <strong>b.&nbsp;{translate('returndatatype__title')}</strong>
                </p>
                <li>
                    <ReturnTypeValue type="text" />
                </li>
                <p>
                    <strong>c.&nbsp;{translate('example__title')}</strong>
                </p>
                <li>

                    <div className='results'>
                        <div className='parameter'>
                            <span className='parameter-name'>{translate('outputkey')}</span>
                            <div>$text_1</div>
                        </div>
                        <div className='parameter'>
                            <span className='parameter-name'>{translate('browser')}</span>
                            <div>$browser_1</div>
                        </div>
                        <div className='parameter'>
                            <span className='parameter-name'>{translate('selector')}</span>
                            <div>p.google</div>
                        </div>
                        <div className='output'>
                            <span className='output-symbol'>&#61;&gt;&nbsp;</span>
                            <div>Google is a technology company</div>
                        </div>
                    </div>
                </li>
            </ul>
            <Typography variant="h5" gutterBottom id="clickpoint">
                10.&nbsp;<span className="material-symbols-outlined">my_location</span>&nbsp;{translate('clickpoint')}
            </Typography>
            <p><strong>{translate('clickpoint')}</strong> Webサイト上にX、Y 座標で指定された位置をクリックするアクションです。</p>
            <p>セレクターが存在する場合、セレクターで指定された要素の左上を基準点として x、y 座標を指定できます。x、y 座標で指定された位置をクリックする操作です　x、y 座標を取得するユーティリティをインストールできます。 <a href="https://chrome.google.com/webstore/detail/coordinates/bpflbjmbfccblbhlcmlgkajdpoiepmkd" target="_blank">こちら</a>.</p>
            <ul style={{ listStyle: "none" }}>
                <p>
                    <strong>a.&nbsp;{translate('parameters__title')}</strong>
                </p>
                <li>
                    <table className='parameters'>
                        <ParametersTableHeader />
                        <tbody>
                            <tr>
                                <td>{translate('browser')}<span>*</span></td>
                                <td>
                                    <ParametersTypeValue type="text" />
                                </td>
                                <td>座標クリックする対象の Web サイトの出力きー</td>
                                <td></td>
                            </tr>
                            <tr>
                                <td>{translate('selector')}</td>
                                <td>
                                    <ParametersTypeValue type="text" />
                                </td>
                                <td> Web サイト上座標クリック位置の CSS セレクタです。CSS セレクタの取得方法は<a href="/control-center/documentation/gettingstarted/usage/#getcssselector" target="_blank">こちら</a> です。</td>
                                <td></td>
                            </tr>
                            <tr>
                                <td>{translate('coordinatex')}<span>*</span></td>
                                <td>
                                    <ParametersTypeValue type="number" />
                                </td>
                                <td>X 座標 (単位はピクセル) です。</td>
                                <td></td>
                            </tr>
                            <tr>
                                <td>{translate('coordinatey')}<span>*</span></td>
                                <td>
                                    <ParametersTypeValue type="number" />
                                </td>
                                <td>Y座標 (単位はピクセル) です。</td>
                                <td></td>
                            </tr>
                            <tr>
                                <td>{translate('waitfornavigation')}</td>
                                <td>
                                    <ParametersTypeValue type="boolean" />
                                </td>
                                <td>これはブラウザのナビゲーション待機アクションです。セレクターを待つスイッチがオン (true) の場合、ブラウザはこのイベントが発生するのを明示的に待機し、次のアクションの実行を続行します。 <strong>{translate('waitfornavigation')}</strong> </td>
                                <td>true</td>
                            </tr>
                            <tr>
                                <td>{translate('acceptdialog')}</td>
                                <td>
                                    <ParametersTypeValue type="boolean" />
                                </td>
                                <td>ダイアログのボタンをクリックするアクション。ダイアログ受入スイッチがオン (true) の場合は、サインイン ボタンをクリックします (補足の番号 ❸ を参照)。 <strong>{translate('acceptdialog')}</strong> <strong>{translate('signin')}</strong></td>
                                <td>true</td>
                            </tr>
                            <tr>
                                <td>{translate('screenshot')}</td>
                                <td>
                                    <ParametersTypeValue type="boolean" />
                                </td>
                                <td>アクションが完了した後に撮影された画像。スクリーンショット <strong>{translate('screenshot')}</strong> スイッチがオン (true) の場合、画像はキャプチャされてストレージに保存されます。 </td>
                                <td>true</td>
                            </tr>
                            <tr>
                                <td>{translate('ignoreerror')}</td>
                                <td>
                                    <ParametersTypeValue type="boolean" />
                                </td>
                                <td>エラーを無視するアクションとして、エラー無視スイッチがオン (true) の場合、CSS セレクターが見つからないなどのエラーが発生した場合でも、ブラウザーはさらなるアクションを続行します。 <strong>{translate('ignoreerror')}</strong> </td>
                                <td>true</td>
                            </tr>
                        </tbody>
                    </table>
                </li>
                <p><strong>{translate('supplement__title')}</strong></p>
                <li>
                    <div className='supplement'>
                        <p>ブラウザにダイアログ ボックスが表示される場合</p>
                        <Zoom>
                            <img src={BasicAuth} width="75%" />
                        </Zoom>
                    </div>
                </li>
                <p>
                    <strong>b.&nbsp;{translate('returndatatype__title')}</strong>
                </p>
                <li>
                    <ReturnTypeValue />
                </li>
                <p>
                    <strong>c.&nbsp;{translate('example__title')}</strong>
                </p>
                <li>

                    <div className='results'>
                        <div className='parameter'>
                            <span className='parameter-name'>{translate('browser')}</span>
                            <div>$text_1</div>
                        </div>
                        <div className='parameter'>
                            <span className='parameter-name'>{translate('coordinatex')}</span>
                            <div>200</div>
                        </div>
                        <div className='parameter'>
                            <span className='parameter-name'>{translate('coordinatey')}</span>
                            <div>500</div>
                        </div>
                    </div>
                </li>
            </ul>
            <Typography variant="h5" gutterBottom id="takescreenshot">
                11.&nbsp;<span className="material-symbols-outlined">panorama</span>&nbsp;{translate('takescreenshot')}
            </Typography>
            <p><strong>{translate('takescreenshot')}</strong> スクリーンショットとはブラウザ画面を画像として保存するアクションです。</p>
            <ul style={{ listStyle: "none" }}>
                <p>
                    <strong>a.&nbsp;{translate('parameters__title')}</strong>
                </p>
                <li>
                    <table className='parameters'>
                        <ParametersTableHeader />
                        <tbody>
                            <tr>
                                <td>{translate('outputkey')}<span>*</span></td>
                                <td>
                                    <ParametersTypeValue type="text" />
                                </td>
                                <td>スクリーンショットの保存ところです。</td>
                                <td>$screenshot_1</td>
                            </tr>
                            <tr>
                                <td>{translate('browser')}<span>*</span></td>
                                <td>
                                    <ParametersTypeValue type="text" />
                                </td>
                                <td>スクリーンショットする対象の Web サイトの出力きー</td>
                                <td></td>
                            </tr>
                            <tr>
                                <td>{translate('clip')}</td>
                                <td>
                                    <ParametersTypeValue type="text" />
                                </td>
                                <td>スクリーンショット画像の切り抜き範囲（左、上、幅、高さ）を指定します。値はカンマで区切られます。空白のままにすると、全画面がキャプチャされます。</td>
                                <td></td>
                            </tr>
                        </tbody>
                    </table>
                </li>
                <p>
                    <strong>b.&nbsp;{translate('returndatatype__title')}</strong>
                </p>
                <li>
                    <ReturnTypeValue type="text" />
                </li>
                <p>
                    <strong>c.&nbsp;{translate('example__title')}</strong>
                </p>
                <li>

                    <div className='results'>
                        <div className='parameter'>
                            <span className='parameter-name'>{translate('outputkey')}</span>
                            <div>$screenshot_1</div>
                        </div>
                        <div className='parameter'>
                            <span className='parameter-name'>{translate('browser')}</span>
                            <div>$browser_1</div>
                        </div>
                        <div className='parameter'>
                            <span className='parameter-name'>{translate('clip')}</span>
                            <div>0,100,500,500</div>
                        </div>
                        <div className='output'>
                            <span className='output-symbol'>&#61;&gt;&nbsp;</span>
                            <div>/tmp/downloads/bot-sktwi9ovlb7lrmpt/his-20221208-0531394260/149a0611.png</div>
                        </div>
                    </div>
                </li>
            </ul>
            <Typography variant="h5" gutterBottom id="pagepdf">
                12.&nbsp;<span className="material-symbols-outlined">panorama</span>&nbsp;{translate('pagepdf')}
            </Typography>
            <p><strong>{translate('pagepdf')}</strong> レンダリングされたページを印刷用に PDF にエクスポートするアクションです。</p>
            <ul style={{ listStyle: "none" }}>
                <p>
                    <strong>a.&nbsp;{translate('parameters__title')}</strong>
                </p>
                <li>
                    <table className='parameters'>
                        <ParametersTableHeader />
                        <tbody>
                            <tr>
                                <td>{translate('outputkey')}<span>*</span></td>
                                <td>
                                    <ParametersTypeValue type="text" />
                                </td>
                                <td>ページ PDFファイルの保存先です。</td>
                                <td>$pdf_1</td>
                            </tr>
                            <tr>
                                <td>{translate('browser')}<span>*</span></td>
                                <td>
                                    <ParametersTypeValue type="text" />
                                </td>
                                <td>ページ PDFする対象の Web サイトの出力きー</td>
                                <td></td>
                            </tr>
                            <tr>
                                <td>{translate('format')}<span>*</span></td>
                                <td>
                                    <ParametersTypeValue type="text" />
                                </td>
                                <td>用紙サイズ</td>
                                <td>A4</td>
                            </tr>
                            <tr>
                                <td>{translate('scale')}</td>
                                <td>
                                    <ParametersTypeValue type="text" />
                                </td>
                                <td>印刷速度</td>
                                <td></td>
                            </tr>
                            <tr>
                                <td>{translate('pageranges')}</td>
                                <td>
                                    <ParametersTypeValue type="text" />
                                </td>
                                <td>印刷するページを指定します。すべてのページを印刷するには空白のままにします。 - 記号を使用して範囲を指定でき、複数の範囲はカンマで区切られます。</td>
                                <td></td>
                            </tr>
                        </tbody>
                    </table>
                </li>
                <p>
                    <strong>b.&nbsp;{translate('returndatatype__title')}</strong>
                </p>
                <li>
                    <ReturnTypeValue type="text" />
                </li>
                <p>
                    <strong>c.&nbsp;{translate('example__title')}</strong>
                </p>
                <li>

                    <div className='results'>
                        <div className='parameter'>
                            <span className='parameter-name'>{translate('outputkey')}</span>
                            <div>pdf_1</div>
                        </div>
                        <div className='parameter'>
                            <span className='parameter-name'>{translate('browser')}</span>
                            <div>$browser_1</div>
                        </div>
                        <div className='parameter'>
                            <span className='parameter-name'>{translate('format')}</span>
                            <div>A4</div>
                        </div>
                        <div className='output'>
                            <span className='output-symbol'>&#61;&gt;&nbsp;</span>
                            <div>/tmp/downloads/bot-sktwi9ovlb7lrmpt/his-20221208-0531394260/149a0611.pdf</div>
                        </div>
                    </div>
                </li>
            </ul>
            <Typography variant="h5" gutterBottom id="hover">
                13.&nbsp;<span className="material-symbols-outlined">mouse</span>&nbsp;{translate('hover')}
            </Typography>
            <p><strong>{translate('hover')}</strong> ブラウザ内の指定された要素の上にマウスを置くアクションです。</p>
            <ul style={{ listStyle: "none" }}>
                <p>
                    <strong>a.&nbsp;{translate('parameters__title')}</strong>
                </p>
                <li>
                    <table className='parameters'>
                        <ParametersTableHeader />
                        <tbody>
                            <tr>
                                <td>{translate('browser')}<span>*</span></td>
                                <td>
                                    <ParametersTypeValue type="text" />
                                </td>
                                <td>マウスホバーする対象の Web サイトの出力きー</td>
                                <td></td>
                            </tr>
                            <tr>
                                <td>{translate('selector')}<span>*</span></td>
                                <td>
                                    <ParametersTypeValue type="text" />
                                </td>
                                <td>Web サイト上マウスホバーする位置の CSS セレクタです。 CSS セレクタの取得方法は<a href="/control-center/documentation/gettingstarted/usage/#getcssselector" target="_blank">こちら</a> です。</td>
                                <td></td>
                            </tr>
                            <tr>
                                <td>{translate('screenshot')}</td>
                                <td>
                                    <ParametersTypeValue type="boolean" />
                                </td>
                                <td>アクションが完了した後に撮影された画像。スクリーンショット <strong>{translate('screenshot')}</strong> スイッチがオン (true) の場合、画像はキャプチャされてストレージに保存されます。</td>
                                <td>true</td>
                            </tr>
                            <tr>
                                <td>{translate('ignoreerror')}</td>
                                <td>
                                    <ParametersTypeValue type="boolean" />
                                </td>
                                <td>エラーを無視するアクションとして、エラー無視スイッチがオン (true) の場合、CSS セレクターが見つからないなどのエラーが発生した場合でも、ブラウザーはさらなるアクションを続行します。 <strong>{translate('ignoreerror')}</strong></td>
                                <td>true</td>
                            </tr>
                        </tbody>
                    </table>
                </li>
                <p>
                    <strong>b.&nbsp;{translate('returndatatype__title')}</strong>
                </p>
                <li>
                    <ReturnTypeValue />
                </li>
                <p>
                    <strong>c.&nbsp;{translate('example__title')}</strong>
                </p>
                <li>

                    <div className='results'>
                        <div className='parameter'>
                            <span className='parameter-name'>{translate('browser')}</span>
                            <div>$browser_1</div>
                        </div>
                        <div className='parameter'>
                            <span className='parameter-name'>{translate('selector')}</span>
                            <div>ul.navigate</div>
                        </div>
                    </div>
                </li>
            </ul>
            <Typography variant="h5" gutterBottom id="scrapepage">
                14.&nbsp;<span className="material-symbols-outlined">list_alt</span>&nbsp;{translate('scrapepage')}
            </Typography>
            <p><strong>{translate('scrapepage')}</strong> CSS セレクターに一致するすべての要素のテキストまたは内部 HTML を取得するアクションです。</p>
            <ul style={{ listStyle: "none" }}>
                <p>
                    <strong>a.&nbsp;{translate('parameters__title')}</strong>
                </p>
                <li>
                    <table className='parameters'>
                        <ParametersTableHeader />
                        <tbody>
                            <tr>
                                <td>{translate('outputkey')}<span>*</span></td>
                                <td>
                                    <ParametersTypeValue type="text" />
                                </td>
                                <td>スクレイピングテキストの保存先です。</td>
                                <td>$scrape_1</td>
                            </tr>
                            <tr>
                                <td>{translate('browser')}<span>*</span></td>
                                <td>
                                    <ParametersTypeValue type="text" />
                                </td>
                                <td>スクレイピング対象の Web サイトの出力きー</td>
                                <td></td>
                            </tr>
                            <tr>
                                <td>{translate('selector')}<span>*</span></td>
                                <td>
                                    <ParametersTypeValue type="text" />
                                </td>
                                <td> Web サイト上スクレイピング位置の CSS セレクタです。CSS セレクタの取得方法は<a href="/control-center/documentation/gettingstarted/usage/#getcssselector" target="_blank">こちら</a> です。</td>
                                <td></td>
                            </tr>
                            <tr>
                                <td>{translate('textonly')}</td>
                                <td>
                                    <ParametersTypeValue type="boolean" />
                                </td>
                                <td>要素内のテキストのみを取得するオプションです。テキストのみスイッチが有効 (true) の場合、結果はテキストになり、それ以外の場合、結果には HTML が含まれます。 <strong>{translate('textonly')}</strong> </td>
                                <td>true</td>
                            </tr>
                            <tr>
                                <td>{translate('ignoreerror')}</td>
                                <td>
                                    <ParametersTypeValue type="boolean" />
                                </td>
                                <td>エラーを無視するアクションとして、エラー無視スイッチがオン (true) の場合、CSS セレクターが見つからないなどのエラーが発生した場合でも、ブラウザーはさらなるアクションを続行します。 <strong>{translate('ignoreerror')}</strong> </td>
                                <td>true</td>
                            </tr>
                        </tbody>
                    </table>
                </li>
                <p>
                    <strong>b.&nbsp;{translate('returndatatype__title')}</strong>
                </p>
                <li>
                    <ReturnTypeValue type="text" />
                </li>
                <p>
                    <strong>c.&nbsp;{translate('example__title')}</strong>
                </p>
                <li>

                    <div className='results'>
                        <div className='parameter'>
                            <span className='parameter-name'>{translate('outputkey')}</span>
                            <div>$scrape_1</div>
                        </div>
                        <div className='parameter'>
                            <span className='parameter-name'>{translate('browser')}</span>
                            <div>$browser_1</div>
                        </div>
                        <div className='parameter'>
                            <span className='parameter-name'>{translate('selector')}</span>
                            <div>p.season</div>
                        </div>
                        <div className='output'>
                            <span className='output-symbol'>&#61;&gt;&nbsp;</span>
                            <div>
                                <pre>
                                    {JSON.stringify(["spring", "summer", "fall", "winter"], null, 2)}
                                </pre>
                            </div>
                        </div>
                    </div>
                </li>
            </ul>
            <Typography variant="h5" gutterBottom id="extractdatafromtable">
                15.&nbsp;<span className="material-symbols-outlined">table</span>&nbsp;{translate('extractdatafromtable')}
            </Typography>
            <p><strong>{translate('extractdatafromtable')}</strong> は、Web サイト上にあるテーブルからテキストを取得するアクションです。</p>
            <ul style={{ listStyle: "none" }}>
                <p>
                    <strong>a.&nbsp;{translate('parameters__title')}</strong>
                </p>
                <li>
                    <table className='parameters'>
                        <ParametersTableHeader />
                        <tbody>
                            <tr>
                                <td>{translate('outputkey')}<span>*</span></td>
                                <td>
                                    <ParametersTypeValue type="text" />
                                </td>
                                <td>配列として取得されるテキスト リストの保存先です。</td>
                                <td>$extractDataFromTable_1</td>
                            </tr>
                            <tr>
                                <td>{translate('browser')}<span>*</span></td>
                                <td>
                                    <ParametersTypeValue type="text" />
                                </td>
                                <td>テーブルからのデータの抽出する対象の Web サイトの出力きー</td>
                                <td></td>
                            </tr>
                            <tr>
                                <td>{translate('selector')}<span>*</span></td>
                                <td>
                                    <ParametersTypeValue type="text" />
                                </td>
                                <td> Web サイト上テーブルからのデータの抽出する位置の CSS セレクタです。CSS セレクタの取得方法は<a href="/control-center/documentation/gettingstarted/usage/#getcssselector" target="_blank">こちら</a> です。</td>
                                <td></td>
                            </tr>
                            <tr>
                                <td>{translate('ignoreerror')}</td>
                                <td>
                                    <ParametersTypeValue type="boolean" />
                                </td>
                                <td>エラーを無視するアクションとして、エラー無視スイッチがオン (true) の場合、CSS セレクターが見つからないなどのエラーが発生した場合でも、ブラウザーはさらなるアクションを続行します。 <strong>{translate('ignoreerror')}</strong> </td>
                                <td>true</td>
                            </tr>
                        </tbody>
                    </table>
                </li>
                <p>
                    <strong>b.&nbsp;{translate('returndatatype__title')}</strong>
                </p>
                <li>
                    <ReturnTypeValue type="array" />
                </li>
                <p>
                    <strong>c.&nbsp;{translate('example__title')}</strong>
                </p>
                <li>

                    <div className='results'>
                        <div className='parameter'>
                            <span className='parameter-name'>{translate('outputkey')}</span>
                            <div>$extractDataFromTable_1</div>
                        </div>
                        <div className='parameter'>
                            <span className='parameter-name'>{translate('browser')}</span>
                            <div>$browser_1</div>
                        </div>
                        <div className='parameter'>
                            <span className='parameter-name'>{translate('selector')}</span>
                            <div>div.exchange-rate-table</div>
                        </div>
                        <div className='output'>
                            <span className='output-symbol'>&#61;&gt;&nbsp;</span>
                            <div>
                                <pre>
                                    {JSON.stringify([
                                        ["No", "Product Name", "Price"],
                                        [1, "Pen", 200],
                                        [2, "note", 500]
                                    ], null, 2)}
                                </pre>
                            </div>
                        </div>
                    </div>
                </li>
            </ul>
            <Typography variant="h5" gutterBottom id="findelement">
                16.&nbsp;<span className="material-symbols-outlined">manage_search</span>&nbsp;{translate('findelement')}
            </Typography>
            <p><strong>{translate('findelement')}</strong> ブラウザに表示されている要素を検索するアクションです。</p>
            <ul style={{ listStyle: "none" }}>
                <p>
                    <strong>a.&nbsp;{translate('parameters__title')}</strong>
                </p>
                <li>
                    <table className='parameters'>
                        <ParametersTableHeader />
                        <tbody>
                            <tr>
                                <td>{translate('outputkey')}<span>*</span></td>
                                <td>
                                    <ParametersTypeValue type="text" />
                                </td>
                                <td>取得される要素の保存先です。</td>
                                <td>$element_1</td>
                            </tr>
                            <tr>
                                <td>{translate('browser')}<span>*</span></td>
                                <td>
                                    <ParametersTypeValue type="text" />
                                </td>
                                <td>要素検索する対象の Web サイトの出力きー</td>
                                <td></td>
                            </tr>
                            <tr>
                                <td>{translate('findelementby')}<span>*</span></td>
                                <td>
                                    <ParametersTypeValue type="text" />
                                </td>
                                <td>
                                ブラウザに表示されている要素を取得するメソッドです。
                                    <ul>
                                        <li> <strong>{translate('text')}</strong> テキストで検索する場合、結果は CSS セレクターの配列になります。</li>
                                        <li><strong>{translate('selector')}</strong>セレクタで検索する場合、結果は  <i>true</i> または<i>false</i>になります。</li>
                                    </ul>
                                </td>
                                <td>text</td>
                            </tr>
                            <tr>
                                <td>{translate('text')}<span>*</span></td>
                                <td>
                                    <ParametersTypeValue type="text" />
                                </td>
                                <td>テキストで検索したい文字</td>
                                <td></td>
                            </tr>
                            <tr>
                                <td>{translate('selector')}<span>*</span></td>
                                <td>
                                    <ParametersTypeValue type="text" />
                                </td>
                                <td>セレクタで検索したい CSS セレクタです。 CSS セレクタの取得方法は<a href="/control-center/documentation/gettingstarted/usage/#getcssselector" target="_blank">こちら</a> です。</td>
                                <td></td>
                            </tr>
                        </tbody>
                    </table>
                </li>
                <p>
                    <strong>b.&nbsp;{translate('returndatatype__title')}</strong>
                </p>
                <li>
                    <ReturnTypeValue type="array" />
                    <br/>
                    <ReturnTypeValue type="boolean" />
                </li>
                <p>
                    <strong>c.&nbsp;{translate('example__title')}</strong>
                </p>
                <li>
                    <div className='results'>
                        <div className='parameter'>
                            <span className='parameter-name'>{translate('outputkey')}</span>
                            <div>$element_1</div>
                        </div>
                        <div className='parameter'>
                            <span className='parameter-name'>{translate('browser')}</span>
                            <div>$browser_1</div>
                        </div>
                        <div className='parameter'>
                            <span className='parameter-name'>{translate('findelementby')}</span>
                            <div>Text</div>
                        </div>
                        <div className='parameter'>
                            <span className='parameter-name'>{translate('text')}</span>
                            <div>Sign In</div>
                        </div>
                        <div className='output'>
                            <span className='output-symbol'>&#61;&gt;&nbsp;</span>
                            <div>
                                <pre>
                                    {JSON.stringify(["input.signin"], null, 2)}
                                </pre>
                            </div>
                        </div>
                    </div>
                </li>
                <br />
                <li>
                    <div className='results'>
                        <div className='parameter'>
                            <span className='parameter-name'>{translate('outputkey')}</span>
                            <div>$element_1</div>
                        </div>
                        <div className='parameter'>
                            <span className='parameter-name'>{translate('browser')}</span>
                            <div>$browser_1</div>
                        </div>
                        <div className='parameter'>
                            <span className='parameter-name'>{translate('findelementby')}</span>
                            <div>Selector</div>
                        </div>
                        <div className='parameter'>
                            <span className='parameter-name'>{translate('text')}</span>
                            <div>input.signin</div>
                        </div>
                        <div className='output'>
                            <span className='output-symbol'>&#61;&gt;&nbsp;</span>
                            <div>true</div>
                        </div>
                    </div>
                </li>
            </ul>
            <Typography variant="h5" gutterBottom id="geturl">
                17.&nbsp;<span className="material-symbols-outlined">lock</span>&nbsp;{translate('geturl')}
            </Typography>
            <p><strong>{translate('geturl')}</strong> 閲覧しているWebサイトのURLを取得するアクションです。</p>
            <ul style={{ listStyle: "none" }}>
                <p>
                    <strong>a.&nbsp;{translate('parameters__title')}</strong>
                </p>
                <li>
                    <table className='parameters'>
                        <ParametersTableHeader />
                        <tbody>
                            <tr>
                                <td>{translate('browser')}<span>*</span></td>
                                <td>
                                    <ParametersTypeValue type="text" />
                                </td>
                                <td>URLを取得したいWeb サイトの出力きー</td>
                                <td></td>
                            </tr>
                        </tbody>
                    </table>
                </li>
                <p>
                    <strong>b.&nbsp;{translate('returndatatype__title')}</strong>
                </p>
                <li>
                    <ReturnTypeValue type="text" />
                </li>
                <p>
                    <strong>c.&nbsp;{translate('example__title')}</strong>
                </p>
                <li>
                    <div className='results'>
                        <div className='parameter'>
                            <span className='parameter-name'>{translate('browser')}</span>
                            <div>$browser_1</div>
                        </div>
                        <div className='output'>
                            <span className='output-symbol'>&#61;&gt;&nbsp;</span>
                            <div>https://rpa-cloud.io/</div>
                        </div>
                    </div>
                </li>
            </ul>
            <Typography variant="h5" gutterBottom id="getattribute">
                18.&nbsp;<span className="material-symbols-outlined">font_download</span>&nbsp;{translate('getattribute')}
            </Typography>
            <p><strong>{translate('getattribute')}</strong> 属性取得は、CSSセレクターで指定された要素の属性値を取得するアクションです。</p>
            <ul style={{ listStyle: "none" }}>
                <p>
                    <strong>a.&nbsp;{translate('parameters__title')}</strong>
                </p>
                <li>
                    <table className='parameters'>
                        <ParametersTableHeader />
                        <tbody>
                            <tr>
                                <td>{translate('browser')}<span>*</span></td>
                                <td>
                                    <ParametersTypeValue type="text" />
                                </td>
                                <td>属性取得する対象の Web サイトの出力きー</td>
                                <td></td>
                            </tr>
                            <tr>
                                <td>{translate('selector')}<span>*</span></td>
                                <td>
                                    <ParametersTypeValue type="text" />
                                </td>
                                <td>属性値を取得したいオブジェクトのCSSセレクターです。CSS セレクタの取得方法は<a href="/control-center/documentation/gettingstarted/usage/#getcssselector" target="_blank">こちら</a> です。</td>
                                <td></td>
                            </tr>
                            <tr>
                                <td>{translate('attribute')}<span>*</span></td>
                                <td>
                                    <ParametersTypeValue type="text" />
                                </td>
                                <td>取得する属性は (id、src、href、alt など) です。</td>
                                <td></td>
                            </tr>
                            <tr>
                                <td>{translate('ignoreerror')}</td>
                                <td>
                                    <ParametersTypeValue type="boolean" />
                                </td>
                                <td>エラーを無視するアクションとして、エラー無視スイッチがオン (true) の場合、CSS セレクターが見つからないなどのエラーが発生した場合でも、ブラウザーはさらなるアクションを続行します。 <strong>{translate('ignoreerror')}</strong> </td>
                                <td>true</td>
                            </tr>
                        </tbody>
                    </table>
                </li>
                <p>
                    <strong>b.&nbsp;{translate('returndatatype__title')}</strong>
                </p>
                <li>
                    <ReturnTypeValue type="text" />
                </li>
                <p>
                    <strong>c.&nbsp;{translate('example__title')}</strong>
                </p>
                <li>
                    <div className='results'>
                        <div className='parameter'>
                            <span className='parameter-name'>{translate('browser')}</span>
                            <div>$browser_1</div>
                        </div>
                        <div className='parameter'>
                            <span className='parameter-name'>{translate('selector')}</span>
                            <div>img.logo</div>
                        </div>
                        <div className='parameter'>
                            <span className='parameter-name'>{translate('attribute')}</span>
                            <div>src</div>
                        </div>
                        <div className='output'>
                            <span className='output-symbol'>&#61;&gt;&nbsp;</span>
                            <div>https://rpa-cloud.io/static/media/logo.c2d9a6453b58088f8c6bb284148a556d.svg</div>
                        </div>
                    </div>
                </li>
            </ul>
            <Typography variant="h5" gutterBottom id="waitforselector">
                19.&nbsp;<span className="material-symbols-outlined">hourglass_empty</span>&nbsp;{translate('waitforselector')}
            </Typography>
            <p><strong>{translate('waitforselector')}</strong> セレクター待機は該当セレクタがWeb上に表示されるまで待つアクションです。 <strong>{translate('selector')}</strong> </p>
            <ul style={{ listStyle: "none" }}>
                <p>
                    <strong>a.&nbsp;{translate('parameters__title')}</strong>
                </p>
                <li>
                    <table className='parameters'>
                        <ParametersTableHeader />
                        <tbody>
                            <tr>
                                <td>{translate('browser')}<span>*</span></td>
                                <td>
                                    <ParametersTypeValue type="text" />
                                </td>
                                <td>セレクター待機する対象の Web サイトの出力きー</td>
                                <td></td>
                            </tr>
                            <tr>
                                <td>{translate('selector')}<span>*</span></td>
                                <td>
                                    <ParametersTypeValue type="text" />
                                </td>
                                <td>待機したいCSSセレクターです。 CSS セレクタの取得方法は<a href="/control-center/documentation/gettingstarted/usage/#getcssselector" target="_blank">こちら</a> です。</td>
                                <td></td>
                            </tr>
                            <tr>
                                <td>{translate('timeout')}</td>
                                <td>
                                    <ParametersTypeValue type="number" />
                                </td>
                                <td>ミリ秒単位の最大待機時間です。空白のままにした場合、デフォルトは 180,000 です。</td>
                                <td></td>
                            </tr>
                            <tr>
                                <td>{translate('screenshot')}</td>
                                <td>
                                    <ParametersTypeValue type="boolean" />
                                </td>
                                <td>アクションが完了した後に撮影された画像。スクリーンショット <strong>{translate('screenshot')}</strong> スイッチがオン (true) の場合、画像はキャプチャされてストレージに保存されます。</td>
                                <td>true</td>
                            </tr>
                            <tr>
                                <td>{translate('ignoreerror')}</td>
                                <td>
                                    <ParametersTypeValue type="boolean" />
                                </td>
                                <td>エラーを無視するアクションとして、エラー無視スイッチがオン (true) の場合、CSS セレクターが見つからないなどのエラーが発生した場合でも、ブラウザーはさらなるアクションを続行します。 <strong>{translate('ignoreerror')}</strong> </td>
                                <td>true</td>
                            </tr>
                        </tbody>
                    </table>
                </li>
                <p>
                    <strong>b.&nbsp;{translate('returndatatype__title')}</strong>
                </p>
                <li>
                    <ReturnTypeValue />
                </li>
                <p>
                    <strong>c.&nbsp;{translate('example__title')}</strong>
                </p>
                <li>
                    <div className='results'>
                        <div className='parameter'>
                            <span className='parameter-name'>{translate('browser')}</span>
                            <div>$browser_1</div>
                        </div>
                        <div className='parameter'>
                            <span className='parameter-name'>{translate('selector')}</span>
                            <div>div.bannel</div>
                        </div>
                    </div>
                </li>
            </ul>
            <Typography variant="h5" gutterBottom id="draganddrop">
                20.&nbsp;<span className="material-symbols-outlined">move_down</span>&nbsp;{translate('draganddrop')}
            </Typography>
            <p><strong>{translate('draganddrop')}</strong> 該当のオブジェクトをドラッグ アンド ドロップ操作のアクションです。</p>
            <ul style={{ listStyle: "none" }}>
                <p>
                    <strong>a.&nbsp;{translate('parameters__title')}</strong>
                </p>
                <li>
                    <table className='parameters'>
                        <ParametersTableHeader />
                        <tbody>
                            <tr>
                                <td>{translate('browser')}<span>*</span></td>
                                <td>
                                    <ParametersTypeValue type="text" />
                                </td>
                                <td>オブジェクトをドラッグ アンド ドロップする対象の Web サイトの出力きー</td>
                                <td></td>
                            </tr>
                            <tr>
                                <td>{translate('targetselector')}<span>*</span></td>
                                <td>
                                    <ParametersTypeValue type="text" />
                                </td>
                                <td>オブジェクトをドラッグしたいCSSセレクターです。CSS セレクタの取得方法は<a href="/control-center/documentation/gettingstarted/usage/#getcssselector" target="_blank">こちら</a> です。</td>
                                <td></td>
                            </tr>
                            <tr>
                                <td>{translate('destinationselector')}<span>*</span></td>
                                <td>
                                    <ParametersTypeValue type="text" />
                                </td>
                                <td>オブジェクトをドロップしたいCSSセレクターです。CSS セレクタの取得方法は<a href="/control-center/documentation/gettingstarted/usage/#getcssselector" target="_blank">こちら</a> です。</td>
                                <td></td>
                            </tr>
                            <tr>
                                <td>{translate('screenshot')}</td>
                                <td>
                                    <ParametersTypeValue type="boolean" />
                                </td>
                                <td>アクションが完了した後に撮影された画像。スクリーンショット <strong>{translate('screenshot')}</strong> スイッチがオン (true) の場合、画像はキャプチャされてストレージに保存されます。</td>
                                <td>true</td>
                            </tr>
                            <tr>
                                <td>{translate('ignoreerror')}</td>
                                <td>
                                    <ParametersTypeValue type="boolean" />
                                </td>
                                <td>エラーを無視するアクションとして、エラー無視スイッチがオン (true) の場合、CSS セレクターが見つからないなどのエラーが発生した場合でも、ブラウザーはさらなるアクションを続行します。 <strong>{translate('ignoreerror')}</strong> </td>
                                <td>true</td>
                            </tr>
                        </tbody>
                    </table>
                </li>
                <p>
                    <strong>b.&nbsp;{translate('returndatatype__title')}</strong>
                </p>
                <li>
                    <ReturnTypeValue />
                </li>
                <p>
                    <strong>c.&nbsp;{translate('example__title')}</strong>
                </p>
                <li>
                    <div className='results'>
                        <div className='parameter'>
                            <span className='parameter-name'>{translate('browser')}</span>
                            <div>$browser_1</div>
                        </div>
                        <div className='parameter'>
                            <span className='parameter-name'>{translate('targetselector')}</span>
                            <div>div#div1</div>
                        </div>
                        <div className='parameter'>
                            <span className='parameter-name'>{translate('destinationselector')}</span>
                            <div>div#div2</div>
                        </div>
                    </div>
                </li>
            </ul>
            <Typography variant="h5" gutterBottom id="injectjavascript">
                21.&nbsp;<span className="material-symbols-outlined">javascript</span>&nbsp;{translate('injectjavascript')}
            </Typography>
            <p><strong>{translate('injectjavascript')}</strong> 該当WebサイトにJavaScript を実行できるようにするアクションです。</p>
            <ul style={{ listStyle: "none" }}>
                <p>
                    <strong>a.&nbsp;{translate('parameters__title')}</strong>
                </p>
                <li>
                    <table className='parameters'>
                        <ParametersTableHeader />
                        <tbody>
                            <tr>
                                <td>{translate('outputkey')}<span>*</span></td>
                                <td>
                                    <ParametersTypeValue type="text" />
                                </td>
                                <td>JavaScript を実行結果の保存先です。</td>
                                <td>$injectJavaScript_1</td>
                            </tr>
                            <tr>
                                <td>{translate('browser')}<span>*</span></td>
                                <td>
                                    <ParametersTypeValue type="text" />
                                </td>
                                <td>JavaScript を実行する対象の Web サイトの出力きー</td>
                                <td></td>
                            </tr>
                            <tr>
                                <td>{translate('code')}<span>*</span></td>
                                <td>
                                    <ParametersTypeValue type="text" />
                                </td>
                                <td>JavaScript文</td>
                                <td></td>
                            </tr>
                            <tr>
                                <td>{translate('screenshot')}</td>
                                <td>
                                    <ParametersTypeValue type="boolean" />
                                </td>
                                <td>アクションが完了した後に撮影された画像。スクリーンショット <strong>{translate('screenshot')}</strong> スイッチがオン (true) の場合、画像はキャプチャされてストレージに保存されます。</td>
                                <td>true</td>
                            </tr>
                        </tbody>
                    </table>
                </li>
                <p>
                    <strong>b.&nbsp;{translate('returndatatype__title')}</strong>
                </p>
                <li>
                    <ReturnTypeValue type="any" />
                </li>
                <p>
                    <strong>c.&nbsp;{translate('example__title')}</strong>
                </p>
                <li>
                    <div className='results'>
                        <div className='parameter'>
                            <span className='parameter-name'>{translate('browser')}</span>
                            <div>$browser_1</div>
                        </div>
                        <div className='parameter'>
                            <span className='parameter-name'>{translate('code')}</span>
                            <div>
                                let x = 1;<br />
                                let y = 2;<br />
                                return x + y;
                            </div>
                        </div>
                        <div className='output'>
                            <span className='output-symbol'>&#61;&gt;&nbsp;</span>
                            <div>3</div>
                        </div>
                    </div>
                </li>
            </ul>
            <Typography variant="h5" gutterBottom id="gotourl">
                22.&nbsp;<span className="material-symbols-outlined">open_in_browser</span>&nbsp;{translate('gotourl')}
            </Typography>
            <p><strong>{translate('gotourl')}</strong> ブラウザのアドレス バーに URL を直接入力して変換できるアクションです。セッションを維持しながらページを転送したり、URL を指定して Web ページの深層にあるレイヤーに瞬時に切り替えたりするために使用できます。</p>
            <ul style={{ listStyle: "none" }}>
                <p>
                    <strong>a.&nbsp;{translate('parameters__title')}</strong>
                </p>
                <li>
                    <table className='parameters'>
                        <ParametersTableHeader />
                        <tbody>
                            <tr>
                                <td>{translate('browser')}<span>*</span></td>
                                <td>
                                    <ParametersTypeValue type="text" />
                                </td>
                                <td>URL に移動する対象の Web サイトの出力きー</td>
                                <td></td>
                            </tr>
                            <tr>
                                <td>{translate('url')}<span>*</span></td>
                                <td>
                                    <ParametersTypeValue type="text" />
                                </td>
                                <td>アクセスしたい Web サイトのアドレスです。</td>
                                <td></td>
                            </tr>
                            <tr>
                                <td>{translate('acceptdialog')}</td>
                                <td>
                                    <ParametersTypeValue type="boolean" />
                                </td>
                                <td> ダイアログ内のボタンをクリックするアクション。ダイアログ受け入れスイッチがオン (true)<strong>{translate('acceptdialog')}</strong> の場合は、<strong>{translate('signin')}</strong> ボタンをクリックします (サイドバー番号 ❸ を参照)。 </td>
                                <td>true</td>
                            </tr>
                            <tr>
                                <td>{translate('screenshot')}</td>
                                <td>
                                    <ParametersTypeValue type="boolean" />
                                </td>
                                <td>アクションが完了した後に撮影された画像。スクリーンショット <strong>{translate('screenshot')}</strong> スイッチがオン (true) の場合、画像はキャプチャされてストレージに保存されます。 </td>
                                <td>true</td>
                            </tr>
                        </tbody>
                    </table>
                </li>
                <p><strong>{translate('supplement__title')}</strong></p>
                <li>
                    <div className='supplement'>
                        <p>ブラウザにダイアログ ボックスが表示される場合</p>
                        <Zoom>
                            <img src={BasicAuth} width="75%" />
                        </Zoom>
                    </div>
                </li>
                <p>
                    <strong>b.&nbsp;{translate('returndatatype__title')}</strong>
                </p>
                <li>
                    <ReturnTypeValue />
                </li>
                <p>
                    <strong>c.&nbsp;{translate('example__title')}</strong>
                </p>
                <li>
                    <div className='results'>
                        <div className='parameter'>
                            <span className='parameter-name'>{translate('browser')}</span>
                            <div>$browser_1</div>
                        </div>
                        <div className='parameter'>
                            <span className='parameter-name'>{translate('url')}</span>
                            <div>https://rpa-cloud.io/signin/</div>
                        </div>
                    </div>
                </li>
            </ul>
            <Typography variant="h5" gutterBottom id="goback">
                23.&nbsp;<span className="material-symbols-outlined">arrow_back</span>&nbsp;{translate('goback')}
            </Typography>
            <p><strong>{translate('goback')}</strong> ナビゲーション履歴の前のページに移動するアクションです。</p>
            <ul style={{ listStyle: "none" }}>
                <p>
                    <strong>a.&nbsp;{translate('parameters__title')}</strong>
                </p>
                <li>
                    <table className='parameters'>
                        <ParametersTableHeader />
                        <tbody>
                            <tr>
                                <td>{translate('browser')}<span>*</span></td>
                                <td>
                                    <ParametersTypeValue type="text" />
                                </td>
                                <td>戻る対象の Web サイトの出力きー</td>
                                <td></td>
                            </tr>
                            <tr>
                                <td>{translate('screenshot')}</td>
                                <td>
                                    <ParametersTypeValue type="boolean" />
                                </td>
                                <td>アクションが完了した後に撮影された画像。スクリーンショット <strong>{translate('screenshot')}</strong> スイッチがオン (true) の場合、画像はキャプチャされてストレージに保存されます。</td>
                                <td>true</td>
                            </tr>
                        </tbody>
                    </table>
                </li>
                <p>
                    <strong>b.&nbsp;{translate('returndatatype__title')}</strong>
                </p>
                <li>
                    <ReturnTypeValue />
                </li>
                <p>
                    <strong>c.&nbsp;{translate('example__title')}</strong>
                </p>
                <li>
                    <div className='results'>
                        <div className='parameter'>
                            <span className='parameter-name'>{translate('browser')}</span>
                            <div>$browser_1</div>
                        </div>
                    </div>
                </li>
            </ul>
            <Typography variant="h5" gutterBottom id="opennewtab">
                24.&nbsp;<span className="material-symbols-outlined">tab</span>&nbsp;{translate('opennewtab')}
            </Typography>
            <p><strong>{translate('opennewtab')}</strong> ブラウザ上で新しいタブ/ウィンドウを開くアクションです。</p>
            <ul style={{ listStyle: "none" }}>
                <p>
                    <strong>a.&nbsp;{translate('parameters__title')}</strong>
                </p>
                <li>
                    <table className='parameters'>
                        <ParametersTableHeader />
                        <tbody>
                            <tr>
                                <td>{translate('browser')}<span>*</span></td>
                                <td>
                                    <ParametersTypeValue type="text" />
                                </td>
                                <td>新タブを開く対象の Web サイトの出力きー</td>
                                <td></td>
                            </tr>
                            <tr>
                                <td>{translate('url')}<span>*</span></td>
                                <td>
                                    <ParametersTypeValue type="text" />
                                </td>
                                <td>アクセスしたい Web サイトのアドレス</td>
                                <td></td>
                            </tr>
                            <tr>
                                <td>{translate('acceptdialog')}</td>
                                <td>
                                    <ParametersTypeValue type="boolean" />
                                </td>
                                <td> ダイアログ内のボタンをクリックするアクション。ダイアログ受け入れスイッチがオン (true)<strong>{translate('acceptdialog')}</strong> の場合は、<strong>{translate('signin')}</strong> ボタンをクリックします (サイドバー番号 ❸ を参照)。 </td>
                                <td>true</td>
                            </tr>
                            <tr>
                                <td>{translate('screenshot')}</td>
                                <td>
                                    <ParametersTypeValue type="boolean" />
                                </td>
                                <td>アクションが完了した後に撮影された画像。スクリーンショット <strong>{translate('screenshot')}</strong> スイッチがオン (true) の場合、画像はキャプチャされてストレージに保存されます。 </td>
                                <td>true</td>
                            </tr>
                        </tbody>
                    </table>
                </li>
                <p><strong>{translate('supplement__title')}</strong></p>
                <li>
                    <div className='supplement'>
                        <p>ブラウザにダイアログ ボックスが表示される場合</p>
                        <Zoom>
                            <img src={BasicAuth} width="75%" />
                        </Zoom>
                    </div>
                </li>
                <p>
                    <strong>b.&nbsp;{translate('returndatatype__title')}</strong>
                </p>
                <li>
                    <ReturnTypeValue />
                </li>
                <p>
                    <strong>c.&nbsp;{translate('example__title')}</strong>
                </p>
                <li>
                    <div className='results'>
                        <div className='parameter'>
                            <span className='parameter-name'>{translate('browser')}</span>
                            <div>$browser_1</div>
                        </div>
                        <div className='parameter'>
                            <span className='parameter-name'>{translate('url')}</span>
                            <div>https://rpa-cloud.io/</div>
                        </div>
                    </div>
                </li>
            </ul>
            <Typography variant="h5" gutterBottom id="switchtab">
                25.&nbsp;<span className="material-symbols-outlined">tab</span>&nbsp;{translate('switchtab')}
            </Typography>
            <p><strong>{translate('switchtab')}</strong> ブラウザ上で開いているタブ/ウィンドウ間を移動するアクションです。</p>
            <ul style={{ listStyle: "none" }}>
                <p>
                    <strong>a.&nbsp;{translate('parameters__title')}</strong>
                </p>
                <li>
                    <table className='parameters'>
                        <ParametersTableHeader />
                        <tbody>
                            <tr>
                                <td>{translate('browser')}<span>*</span></td>
                                <td>
                                    <ParametersTypeValue type="text" />
                                </td>
                                <td>タブ切り替え対象の Web サイトの出力きー</td>
                                <td></td>
                            </tr>
                            <tr>
                                <td>{translate('tab')}<span>*</span></td>
                                <td>
                                    <ParametersTypeValue type="number" />
                                </td>
                                <td>移動したいタブの位置です。最も古いタブを指定するには、1 を入力します。タブを開いた順に「1」、「2」・・・となります。タブ表示で取得できるTabオブジェクトそのものを指定することもできます。<strong>{translate('showtabs')}</strong>.</td>
                                <td></td>
                            </tr>
                            <tr>
                                <td>{translate('screenshot')}</td>
                                <td>
                                    <ParametersTypeValue type="boolean" />
                                </td>
                                <td>アクションが完了した後に撮影された画像。スクリーンショット <strong>{translate('screenshot')}</strong> スイッチがオン (true) の場合、画像はキャプチャされてストレージに保存されます。</td>
                                <td>true</td>
                            </tr>
                        </tbody>
                    </table>
                </li>
                <p>
                    <strong>b.&nbsp;{translate('returndatatype__title')}</strong>
                </p>
                <li>
                    <ReturnTypeValue />
                </li>
                <p>
                    <strong>c.&nbsp;{translate('example__title')}</strong>
                </p>
                <li>
                    <div className='results'>
                        <div className='parameter'>
                            <span className='parameter-name'>{translate('browser')}</span>
                            <div>$browser_1</div>
                        </div>
                    </div>
                </li>
            </ul>
            <Typography variant="h5" gutterBottom id="showtabs">
                26.&nbsp;<span className="material-symbols-outlined">tab_unselected</span>&nbsp;{translate('showtabs')}
            </Typography>
            <p><strong>{translate('showtabs')}</strong> ブラウザのタブを閉じるアクションです。</p>
            <ul style={{ listStyle: "none" }}>
                <p>
                    <strong>a.&nbsp;{translate('parameters__title')}</strong>
                </p>
                <li>
                    <table className='parameters'>
                        <ParametersTableHeader />
                        <tbody>
                            <tr>
                                <td>{translate('outputkey')}<span>*</span></td>
                                <td>
                                    <ParametersTypeValue type="text" />
                                </td>
                                <td>Is where the output of this action and the list of tabs/windows are stored as an array.</td>
                                <td>$tabs_1</td>
                            </tr>
                            <tr>
                                <td>{translate('browser')}<span>*</span></td>
                                <td>
                                    <ParametersTypeValue type="text" />
                                </td>
                                <td>タブを閉じる対象の Web サイトの出力きー</td>
                                <td></td>
                            </tr>
                        </tbody>
                    </table>
                </li>
                <p>
                    <strong>b.&nbsp;{translate('returndatatype__title')}</strong>
                </p>
                <li>
                    <ReturnTypeValue type="array" />
                </li>
                <p>
                    <strong>c.&nbsp;{translate('example__title')}</strong>
                </p>
                <li>
                    <div className='results'>
                        <div className='parameter'>
                            <span className='parameter-name'>{translate('outputkey')}</span>
                            <div>$tabs_1</div>
                        </div>
                        <div className='parameter'>
                            <span className='parameter-name'>{translate('browser')}</span>
                            <div>$browser_1</div>
                        </div>
                        <div className='output'>
                            <span className='output-symbol'>&#61;&gt;&nbsp;</span>
                            <div>
                                <pre>
                                    {JSON.stringify(
                                        [
                                            {
                                                "id": 1,
                                                "url": "https://rpa-cloud.io/",
                                                "title": "RPA CLOUD",
                                            }
                                        ], null, 2)}
                                </pre>
                            </div>
                        </div>
                    </div>
                </li>
            </ul>
            <Typography variant="h5" gutterBottom id="closetab">
                27.&nbsp;<span className="material-symbols-outlined">tab_close</span>&nbsp;{translate('closetab')}
            </Typography>
            <p><strong>{translate('closetab')}</strong> ブラウザ上で開いているタブ/ウィンドウを閉じるアクションです。</p>
            <ul style={{ listStyle: "none" }}>
                <p>
                    <strong>a.&nbsp;{translate('parameters__title')}</strong>
                </p>
                <li>
                    <table className='parameters'>
                        <ParametersTableHeader />
                        <tbody>
                            <tr>
                                <td>{translate('browser')}<span>*</span></td>
                                <td>
                                    <ParametersTypeValue type="text" />
                                </td>
                                <td>ブラウザを閉じる対象の Web サイトの出力きー</td>
                                <td></td>
                            </tr>
                            <tr>
                                <td>{translate('tab')}<span>*</span></td>
                                <td>
                                    <ParametersTypeValue type="number" />
                                </td>
                                <td>タブを閉じたいポジションです。 "1", "2"はタブの代表で 1は最古タブをしめします。  <strong>{translate('showtabs')}</strong>.</td>
                                <td></td>
                            </tr>
                            <tr>
                                <td>{translate('screenshot')}</td>
                                <td>
                                    <ParametersTypeValue type="boolean" />
                                </td>
                                <td>アクションが完了した後に撮影された画像。スクリーンショット <strong>{translate('screenshot')}</strong> スイッチがオン (true) の場合、画像はキャプチャされてストレージに保存されます。 </td>
                                <td>true</td>
                            </tr>
                        </tbody>
                    </table>
                </li>
                <p>
                    <strong>b.&nbsp;{translate('returndatatype__title')}</strong>
                </p>
                <li>
                    <ReturnTypeValue />
                </li>
                <p>
                    <strong>c.&nbsp;{translate('example__title')}</strong>
                </p>
                <li>
                    <div className='results'>
                        <div className='parameter'>
                            <span className='parameter-name'>{translate('browser')}</span>
                            <div>$browser_1</div>
                        </div>
                    </div>
                </li>
            </ul>
            <Typography variant="h5" gutterBottom id="closebrowser">
                28.&nbsp;<span className="material-symbols-outlined">web_asset_off</span>&nbsp;{translate('closebrowser')}
            </Typography>
            <p><strong>{translate('closebrowser')}</strong> ブラウザ上で開いているタブ/ウィンドウを閉じるアクションです。</p>
            <ul style={{ listStyle: "none" }}>
                <p>
                    <strong>a.&nbsp;{translate('parameters__title')}</strong>
                </p>
                <li>
                    <table className='parameters'>
                        <ParametersTableHeader />
                        <tbody>
                            <tr>
                                <td>{translate('browser')}<span>*</span></td>
                                <td>
                                    <ParametersTypeValue type="text" />
                                </td>
                                <td>ブラウザを閉じる対象の Web サイトの出力きー</td>
                                <td></td>
                            </tr>
                        </tbody>
                    </table>
                </li>
                <p>
                    <strong>b.&nbsp;{translate('returndatatype__title')}</strong>
                </p>
                <li>
                    <ReturnTypeValue />
                </li>
                <p>
                    <strong>c.&nbsp;{translate('example__title')}</strong>
                </p>
                <li>
                    <div className='results'>
                        <div className='parameter'>
                            <span className='parameter-name'>{translate('browser')}</span>
                            <div>$browser_1</div>
                        </div>
                    </div>
                </li>
            </ul>
        </Box>
    );
}
export default withTranslate(En);